import { useToast } from '@chakra-ui/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from 'services/api/api';

import { mapErrorToToastProps } from '../../../utils/forms/mapErrorToToastProps';

export const createFamily = async body => {
	const response = await api.post('/family', body);
	return response.data;
};

export const useCreateFamily = (
	form?,
	setForm?,
	inputName?: string,
	formProps?,
	setId?,
	setAutocompleteData?
) => {
	const queryClient = useQueryClient();
	const toast = useToast();

	return useMutation(createFamily, {
		onSuccess: success => {
			queryClient.invalidateQueries(['family-list']);
			queryClient.invalidateQueries(['family-list-with-products']);

			toast({
				title: 'Criado com sucesso!',
				description: 'Família criada com sucesso.',
				position: 'bottom-left',
				status: 'success',
				duration: 8000,
				isClosable: true,
			});

			if (form && setForm) {
				setForm({
					...form,
					familia: success.id,
				});
			}

			if (inputName && formProps) {
				const { setValue } = formProps;

				setValue(inputName, String(success.id));

				if (setId) {
					setId(success.id);
				}

				if (setAutocompleteData)
					setAutocompleteData(prev => ({
						...prev,
						family: success,
					}));
			}
		},
		onError: (error: any, variables, context) => {
			const toastErrors: Array<any> = mapErrorToToastProps(
				error,
				'Erro ao cadastrar Família!'
			);
			toastErrors?.forEach(element => toast(element));
		},
	});
};
